module.exports = __webpack_public_path__ + "static/media/alpha-jack.cd572c03.jpg";